const commonParam = {
  // 系统名称
  systemName: "smescplatform",
  // 服务器路径
  //serverUrl: "http://127.0.0.1:26000",
  //serverUrl: "http://192.168.1.214:25000/",
  serverUrl: "https://api3.smesc.cn",
  //密码加密公钥
  getPublicKeyUrl: "/uaa/public-key",
  // 文件下载路径
  downloadUrl: "/download",
  // 图片地址接口地址
  //imageServerUrl: "http://192.168.1.212/smesc",
  imageServerUrl: "https://eps.smesc.cn/img",
  //门户写入token的地址
  portalSaveTokenUrl: "",
  // 操作方式
  handleType: {
    addType: "ADD",
    updateType: "UPDATE",
    lookType: "LOOK"
  },
  // token过期时间(毫秒)比服务器值减少1分钟
  tokenOverdueTime: 7140 * 1000,
  // 刷新token过期时间(毫秒)比服务器值减少1分钟
  refreshTokenOverdueTime: 259140 * 1000,
  // 页眉名字
  headerName: "四川省中小企业公共服务平台",
  // 首页左上角名字
  tabName: "中小企业公共服务平台",
  // 登录页面名字
  loginPlatformName: "中小企业公共服务平台",
  // 系统脚下名字
  footerText: "系统版本v20241008&nbsp;电话：028-83228797&nbsp;QQ群：286209162（系统问题请加QQ群反馈）",
  sysVersion: "v20241008",
  // 限制接口权限页面展示
  flgBtn: false,
};

export default commonParam;
